"use client";
import { useEffect, useState } from "react";
import NewsGrid from "@/components/NewsGrid";

const placeholderImage =
  "https://dummyimage.com/300x200/cccccc/ffffff&text=No+Image";
const mockNews = Array.from({ length: 20 }, (_, index) => ({
  id: `mock-${index + 1}`,
  title: `Mock News ${index + 1}`,
  description: `This is a description for mock news ${index + 1}.`,
  image_url: placeholderImage,
  url: "#",
  published_at: "2025-04-08",
  category: ["Forex", "Crypto", "Markets", "Business"][index % 4],
}));

export default function LastestNew() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await fetch(
          `https://www.alphavantage.co/query?function=NEWS_SENTIMENT&apikey=YOUR_API_KEY&topics=forex,finance,economy&limit=50`
        );
        const result = await response.json();
        const apiNews = (result.feed || []).map((item, idx) => ({
          id: `api-${idx}`,
          title: item.title,
          description: item.summary || "No description",
          image_url: item.banner_image || placeholderImage,
          url: item.url,
          published_at: item.time_published,
          category: item.topic || "Other",
        }));

        const finalData = apiNews.length > 0 ? apiNews : mockNews;
        setNews(finalData);
        localStorage.setItem("allNews", JSON.stringify(finalData));
      } catch (e) {
        console.error("API failed. Using mock data.", e);
        setNews(mockNews);
        localStorage.setItem("allNews", JSON.stringify(mockNews));
      }
    }

    fetchNews();
  }, []);

  return (
    <div style={{ padding: 40, backgroundColor: "white" }}>
      <NewsGrid news={news} />
    </div>
  );
}
